import Reveal from "@/components/base/Reveal";
import { materialRatio, rankingList } from "@/mocks/home";

export default function InsightsSection() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1400px] px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="text-xs font-medium tracking-[0.24em] text-primary-600">
                DATA &amp; RANKING
              </span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                材料分布与热度排行
              </h2>
            </div>
            <p className="max-w-xl text-sm leading-relaxed text-secondary-600">
              看看材料集中在哪一层，也看看大家都在追哪条线，下面的排名每两小时刷新一次。
            </p>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-12">
          {/* 材料占比 */}
          <Reveal className="lg:col-span-5">
            <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <div className="flex items-center gap-2">
                <i className="ri-pie-chart-2-line text-lg text-accent-600" />
                <h3 className="font-heading text-base font-semibold text-foreground-950">
                  材料分类占比
                </h3>
              </div>
              <p className="mt-2 text-xs text-secondary-500">
                基于当前收录的 536 份材料统计
              </p>

              <div className="mt-6 space-y-5">
                {materialRatio.map((item) => (
                  <div key={item.label}>
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-foreground-800">{item.label}</span>
                      <span className="font-heading font-semibold text-foreground-950">
                        {item.value}%
                      </span>
                    </div>
                    <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-accent-500"
                        style={{ width: `${item.value}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-6 grid grid-cols-2 gap-3 border-t border-background-200 pt-5">
                <div className="rounded-md bg-primary-50 px-4 py-3">
                  <span className="font-heading text-xl font-bold text-primary-700">
                    4 处
                  </span>
                  <span className="mt-0.5 block text-xs text-secondary-600">
                    时间戳对不上
                  </span>
                </div>
                <div className="rounded-md bg-secondary-100 px-4 py-3">
                  <span className="font-heading text-xl font-bold text-secondary-900">
                    6 处
                  </span>
                  <span className="mt-0.5 block text-xs text-secondary-600">
                    上下文缺失
                  </span>
                </div>
              </div>
            </div>
          </Reveal>

          {/* 排行榜 */}
          <Reveal className="lg:col-span-7" delay={100}>
            <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <i className="ri-fire-line text-lg text-primary-600" />
                  <h3 className="font-heading text-base font-semibold text-foreground-950">
                    大家都在看
                  </h3>
                </div>
                <span className="text-xs text-secondary-500">每 2 小时刷新</span>
              </div>

              <ul className="mt-4 flex flex-1 flex-col divide-y divide-background-200">
                {rankingList.map((item) => (
                  <li key={item.rank}>
                    <a
                      href="#featured"
                      className="group flex items-center gap-4 py-3.5"
                    >
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                          item.rank <= 3
                            ? "bg-primary-500 text-background-50"
                            : "bg-secondary-100 text-secondary-700"
                        }`}
                      >
                        {item.rank}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block truncate font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
                          {item.title}
                        </span>
                        <span className="mt-1 flex items-center gap-2">
                          <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-700">
                            {item.tag}
                          </span>
                          <span className="text-[11px] text-secondary-500">
                            {item.heat} 热度
                          </span>
                        </span>
                      </span>
                      <i className="ri-arrow-right-s-line shrink-0 text-lg text-secondary-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-600" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}